import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { jsonResponseApi } from '../models/json-response.model';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  redirectionTimestamp: Number;

  constructor(public httpClient: HttpClient) {}

  public get(url, params?) {
    return new Promise((resolve, reject) => {
      this.httpClient
        .get(environment.urls.apiBaseUrl + url, {
          params,
        })
        .subscribe({
          next: (res) => {
            resolve(res);
          },
          error: (error) => {
            this.handleSessionError(error);
            return reject(error);
          },
        });
    });
  }

  public post(url, params) {
    return new Promise((resolve, reject) => {
      this.httpClient
        .post<any>(environment.urls.apiBaseUrl + url, params)
        .subscribe({
          next: (res) => {
            resolve(res);
          },
          error: (error) => {
            this.handleSessionError(error);
            return reject(error);
          },
        });
    });
  }

  jsonParse(pObjJSON: jsonResponseApi): any {
    if (pObjJSON.is_ok == true) {
      return JSON.parse(pObjJSON.original_response);
    } else {
      return 'false';
    }
  }

  stringParser(data): string {
    if (data.is_ok == true) {
      return data.original_response;
    } else {
      return 'false';
    }
  }

  public getLighthouseUrl(appUuid: string) {
    return environment.urls.lighthouseBaseUrl + appUuid + '/dashboard';
  }

  public redirectToLogin() {
    window.location.href = environment.urls.apiBaseUrl + 'login';
  }

  public handleSessionError(error) {
    if (error.status !== 0) {
      // Unknown error that should be managed by the component
      return;
    }
    if (!this.isRecentRedirection()) {
      this.redirectionTimestamp = new Date().getTime();
      this.redirectToLogin();
    }
  }

  isRecentRedirection() {
    const tenSecsAgo = new Date().getTime() - 10000;
    return this.redirectionTimestamp > tenSecsAgo;
  }
}
